import React from 'react';

import LoadingIcon from '@/assets/icons/Loading.gif';
import * as APPDATA from '@/constants/pcConstAppData';
import {newLineHtml} from '@/libs/htmlHelper';

import './ShutdownPage.less';

function ShutdownPage() {
  return (
    <div className="shutdownPage">
      <div className="rowImage">
        <img
          className="loadingIcon"
          src={LoadingIcon}
          alt={LoadingIcon}
          width={125}
          height={125}
        />
      </div>
      <div className="rowText">
        <span className="text">{newLineHtml(APPDATA.MESSAGES.SHUTTINGDOWN)}</span>
      </div>
    </div>
  );
}

export default ShutdownPage;
